  <div class="media profile-media"  (click)="toggleDropdown($event)">
    <!-- <img class="b-r-10 cursor-pointer" src="./assets/svg/profile_img.svg" alt=""> -->
    <div class=""><span>{{loginModel?.name}}</span>
      <p class="mb-0 font-roboto">{{loginModel?.role}} <i class="middle fa fa-angle-down"
        [ngClass]="{'rotated': isDropdownOpen}"></i></p>
    </div>
  </div>  
  <ul class="profile-dropdown onhover-show-div"  [ngClass]="{'mobile-show': isDropdownOpen}" (click)="$event.stopPropagation()">
    <!-- <li><a href="/user/profile"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span></a></li>
    <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li>
    <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li>
    <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li> -->
    <li class="hover-text" (click)="logoutFunc()">
      <app-feather-icons [icon]="'log-in'"></app-feather-icons><span >Log out</span>
    
    </li>
  </ul>




<!-- <div class="media profile-media" (click)="toggleDropdown($event)"> -->
  <!-- <img class="b-r-10 cursor-pointer" src="./assets/svg/profile_img.svg" alt=""> -->
  <!-- <div class="">
    <span>{{loginModel?.name}}</span>
    <p class="mb-0 font-roboto">
      {{loginModel?.role}} 
      <i class="middle fa fa-angle-down" [ngClass]="{'rotated': isDropdownOpen}"></i>
    </p>
  </div>
</div>  

<ul class="profile-dropdown onhover-show-div" 
    [ngClass]="{'mobile-show': isDropdownOpen}"
    (click)="$event.stopPropagation()"> -->
  <!-- <li><a href="/user/profile"><app-feather-icons [icon]="'user'"></app-feather-icons><span>Account </span></a></li>
  <li><a href="email"><app-feather-icons [icon]="'mail'"></app-feather-icons><span>Inbox</span></a></li>
  <li><a href="/to-do"><app-feather-icons [icon]="'file-text'"></app-feather-icons><span>Taskboard</span></a></li>
  <li><a href="/faq"><app-feather-icons [icon]="'settings'"></app-feather-icons><span>Settings</span></a></li> -->
  <!-- <li class="hover-text" (click)="logoutFunc()">
    <app-feather-icons [icon]="'log-in'"></app-feather-icons>
    <span>Log out</span>
  </li>
</ul> -->